import type { FormatterArgs } from '@/services/types/formatter';

export default ({ ctx, data, key }: FormatterArgs) => {
  if (!data[key] && data[key] !== 0) return;

  const text = data[key] === 1 ? ctx.t('Yes') : ctx.t('No');

  return { kind: 'text-block', text };
};
